<template>
    <v-container class="damagereport">
        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="adddamagereport">
            <v-layout row wrap>

                <v-flex xs12 md6 pr-2>
                    <v-card style="height:100%">
                        <v-card-title class="pb-1">
                            <h3 class="headline mb-0">Versicherung</h3>
                        </v-card-title>
                        <v-card-text>
                            <table class="w-100">
                                <tr v-if="contract.productpartner">
                                    <th><img v-if="contract.productpartner.logo_url" :src="contract.productpartner.logo_url" :title="`Logo von: ${contract.productpartner.name}`" :alt="contract.productpartner.name" style="height:78px;width:auto;max-width:100%;" /></th>
                                    <td style="vertical-align:bottom">{{ contract.productpartner.name }}</td>
                                </tr>
                                <tr v-if="contract.productpartner && contract.productpartner.schadenhotline">
                                    <th>Schadenhotline</th>
                                    <td>{{ contract.productpartner.schadenhotline.fon }}</td>
                                </tr>
                                <tr>
                                    <th>Versicherungsart</th>
                                    <td>{{ contract.kind }}</td>
                                </tr>
                                <tr>
                                    <th>Vertragsnummer</th>
                                    <td>{{ contract.vertragsnummer }}</td>
                                </tr>
                                <tr>
                                    <th>Status</th>
                                    <td class="green--text">{{ contract.status ? contract.status : 'Vertrag' }}</td>
                                </tr>
                            </table>
                        </v-card-text>
                    </v-card>
                </v-flex>

                <v-flex xs12 md6 pl-2>
                    <v-card style="height:100%">
                        <v-card-title class="pb-1">
                            <h3 class="headline mb-0">Meine Daten</h3>
                        </v-card-title>
                        <v-card-text>
                            <table class="w-100">
                                <tr>
                                    <th>Name</th>
                                    <td>{{ damagereport.owner_name }}</td>
                                </tr>
                                <tr>
                                    <th>Adresse</th>
                                    <td v-html="damagereport.owner_street ? `${damagereport.owner_street}<br/>${damagereport.owner_additional ? damagereport.owner_additional+'<br/>' : ''}${damagereport.owner_zipcode ? damagereport.owner_zipcode : ''} ${damagereport.owner_city ? damagereport.owner_city+'<br/>' : ''}${damagereport.owner_countrycode ? countryoptions.find(c => {return c.value == damagereport.owner_countrycode}).text : 'Deutschland'}` : ``"></td>
                                </tr>
                                <tr>
                                    <th>E-Mail-Adresse</th>
                                    <td>{{ damagereport.owner_email }}</td>
                                </tr>
                                <tr>
                                    <th>Telefonnummer</th>
                                    <td>{{ damagereport.owner_fon }}</td>
                                </tr>
                            </table>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                        <v-btn absolute dark fab bottom right color="black" v-on="on" to="/settings"><v-icon>edit</v-icon></v-btn>
                                </template>
                                <span>Daten bearbeiten</span>
                            </v-tooltip>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-layout row wrap>
                <v-flex mt-3>
                    <v-card>
                        <v-card-title class="pb-1">
                            <h3 class="headline mb-0">Angaben zum Schadensfall</h3>
                        </v-card-title>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 md6 px-1>
                                    <v-text-field v-model="damagereport.date" type="date" :rules="[rules.required, rules.maxdate]" :max="$moment().format('YYYY-MM-DD').toString()" label="Datum/ Schadenstag *" clearable required />
                                </v-flex>
                                <v-flex xs12 md6 px-1>
                                    <v-text-field v-model="damagereport.time" type="time" :rules="[rules.required]" label="Uhrzeit/ Schadenszeit *" clearable required />
                                </v-flex>
                                <v-flex xs12 md6 px-1>
                                    <v-text-field v-model="damagereport.street" type="text" name="street" maxlength="60" :rules="[rules.required]" label="Straße *" hint="Inklusive der Hausnummer" clearable required />
                                </v-flex>
                                <v-flex xs12 md3 px-1>
                                    <v-text-field v-model="damagereport.zipcode" type="number" name="zipcode" min="01000" max="99998" :rules="[rules.required]" label="Postleitzahl (PLZ) *" hint="Ohne führende Nullen" clearable required />
                                </v-flex>
                                <v-flex xs12 md3 px-1>
                                    <v-text-field v-model="damagereport.city" type="text" name="city" maxlength="36" :rules="[rules.required]" label="Ort *" clearable required />
                                </v-flex>
                                <v-flex xs12 px-1>
                                    <v-textarea rows="10" v-model="damagereport.description" label="Schadenshergang" hint="Schildern Sie, was, aus welchem Grund passiert ist."></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>

                <v-flex v-if="has_haftpflicht" mt-3>
                    <v-card>
                        <v-card-title class="pb-1">
                            <h3 class="headline mb-0">Angaben zum Geschädigten</h3>
                        </v-card-title>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 md2 px-1>
                                    <v-autocomplete v-model="damagereport.victim_salutation" :items="['Herr', 'Frau', 'Divers']" open-on-clear label="Anrede *" required />
                                </v-flex>
                                <v-flex xs12 md4 px-1>
                                    <v-text-field v-model="damagereport.victim_forename" type="text" maxlength="36" :rules="[rules.required]" label="Vorname *" clearable required />
                                </v-flex>
                                <v-flex xs12 md6 px-1>
                                    <v-text-field v-model="damagereport.victim_surname" type="text" maxlength="36" :rules="[rules.required]" label="Nachname *" clearable required />
                                </v-flex>
                                <v-flex xs12 md6 px-1>
                                    <v-text-field v-model="damagereport.victim_street" type="text" maxlength="60" :rules="[rules.required]" label="Straße *" hint="Inklusive der Hausnummer" clearable required />
                                </v-flex>
                                <v-flex xs12 md3 px-1>
                                    <v-text-field v-model="damagereport.victim_zipcode" type="number" min="01000" max="99998" :rules="[rules.required]" label="Postleitzahl (PLZ) *" hint="Ohne führende Nullen" clearable required />
                                </v-flex>
                                <v-flex xs12 md3 px-1>
                                    <v-text-field v-model="damagereport.victim_city" type="text" maxlength="36" :rules="[rules.required]" label="Ort *" clearable required />
                                </v-flex>
                                <v-flex xs12 md6 px-1>
                                    <v-text-field v-model="damagereport.victim_additional" type="text" label="C/O, Adresszusatz" maxlength="36" clearable />
                                </v-flex>
                                <v-flex xs12 md6 px-1>
                                    <v-autocomplete :items="countryoptions" v-model="damagereport.victim_countrycode" open-on-clear label="Land" maxlength="36" clearable />
                                </v-flex>
                                <v-flex xs12 md6 px-1>
                                    <v-text-field v-model="damagereport.victim_fon" type="tel" label="Telefonnummer" clearable />
                                </v-flex>
                                <v-flex xs12 md6 px-1>
                                    <v-text-field v-model="damagereport.victim_email" type="email" :rules="[rules.email]" label="E-Mail-Adresse" clearable />
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>

                <v-flex xs12 mt-3>
                    <v-card>
                        <v-card-title class="pb-1">
                            <h3 class="headline mb-0">Dokumente/ Bilder</h3>
                        </v-card-title>
                        <v-card-text>
                            <v-list two-line subheader>
                                <v-list-tile v-for="(file, index) in files" :key="index" avatar>
                                    <v-list-tile-avatar>
                                        <v-icon v-if="(file.type.search('image') < 0)" class="blue white--text">assignment</v-icon>
                                        <v-icon v-if="(file.type.search('image') >= 0)"  class="amber white--text">photo</v-icon>
                                    </v-list-tile-avatar>

                                    <v-list-tile-content @click="getInfoModal(file)">
                                        <v-list-tile-title>{{ file.file_name }}</v-list-tile-title>
                                        <v-list-tile-sub-title>vom: {{ new Date() | moment("DD.MM.YYYY") }}</v-list-tile-sub-title>
                                        <!-- <v-progress-linear v-if="file.progress" :value="file.progress" height="5" color="black"></v-progress-linear> -->
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-menu bottom left>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                            </template>

                                            <v-list>
                                                <v-list-tile :ripple="{ class: 'black--text' }" @click="getFilenameRewriteModal(file)">
                                                    <v-list-tile-title><v-icon left>edit_attributes</v-icon> Umbenennen</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile :ripple="{ class: 'red--text' }" @click="files.splice(index, 1);">
                                                    <v-list-tile-title><v-icon left>delete_outline</v-icon> Entfernen</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>

                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <v-btn absolute dark fab bottom right color="black" v-on="on" @click="$refs.docUploadInput.click()"><v-icon>add</v-icon></v-btn>
                                </template>
                                <span>Dokumente hinzufügen</span>
                            </v-tooltip>
                        </v-card-text>
                    </v-card>
                </v-flex>

                <v-flex xs12 mt-5 class="text-xs-center">
                    <v-btn color="black" dark @click="adddamagereport" :loading="loading" :disabled="!valid">Schaden an Versicherer senden <v-icon right>send</v-icon></v-btn>
                </v-flex>
            </v-layout>
        </v-form>

        <v-dialog v-model="message_modal_show" width="968">
        <v-card>
            <v-card-text>
                <div>
                    <v-img v-if="message_modal_item.file_type=='image'" :src="message_modal_item.file_url" :title="`Dateiname: ${message_modal_item.file_name}`" alt="Bild nicht aufrufbar" contain></v-img>
                    <object v-if="message_modal_item.file_type=='pdf'" :data="message_modal_item.file_url" type="application/pdf" class="pdfpreview">
                        <iframe :src="message_modal_item.file_url" class="pdfpreview" id="pdfpreview_iframe">
                            <p>Wir können Dir auf diesem Gerät keine PDFs anzeigen; bitte die Datei stattdessen herunterladen: <a :href="message_modal_item.file_url" target="_blank" download>PDF herunterladen</a>.</p>
                        </iframe>
                    </object>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
        <input type="file" ref="docUploadInput" @change="onFileChanged" accept="application/pdf, image/*" multiple hidden />

        <v-bottom-sheet v-model="filename_modal_show" lazy inset>
            <v-card class="pa-3" tile>
                <v-form lazy-validation @submit.prevent="setFilename">
                    <v-layout row wrap justify-center>
                        <v-text-field
                            ref="filename_modal_item_name"
                            type="text"
                            v-model="filename_modal_item_name"
                            :rules="[() => !!filename_modal_item_name || 'Pflichtfeld - Bitte ausfüllen', () => !!filename_modal_item_name && filename_modal_item_name.length >= 3 || 'Die Dateibezeichnung sollte aus mind. 3 Zeichen bestehen']"
                            label="Dokumentenbezeichnung *"
                            maxlength="60"
                            clearable
                            required
                        />
                    </v-layout>
                    <v-card-actions class="pa-0">
                        <v-btn flat color="secondary" @click="filename_modal_show = false">Abbrechen</v-btn>
                        <v-spacer />
                        <v-btn color="black" @click="setFilename" dark>Speichern</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-bottom-sheet>

        <v-dialog v-model="showDirectDamagereportToPartnerModal" absolute max-width="600">
            <v-card v-if="contract.productpartner">
                <v-card-title class="headline">
                    <v-icon left>local_hospital</v-icon>
                    <span class="text-truncate">Schaden melden</span>
                </v-card-title>
                <v-card-text>
                    <p>Die {{ contract.productpartner.name ? contract.productpartner.name : 'Versicherung' }} hat eine eigene Online-Schadensmeldung. Sie können selbst wählen, ob Sie den Schaden über VAPP melden oder direkt bei der Versicherung.</p>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn flat @click="showDirectDamagereportToPartnerModal = false">Über VAPP melden</v-btn>
                    <v-spacer />
                    <v-btn color="black" dark @click="$router.back()" :href="contract.productpartner.damage_url" target="_blank">Beim Versicherer melden <v-icon right>open_in_new</v-icon></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import { COUNTRY_OPTIONS } from '@/constants.js'

export default {
    data () {
        return {
            loading: false,
            damagereport:{
                street: '',
                zipcode: '',
                city: '',
                date: '',
                time: '',
                victim_salutation: '',
                victim_forename: '',
                victim_surname: '',
                victim_street: '',
                victim_additional: '',
                victim_zipcode: '',
                victim_city: '',
                victim_countrycode: 'DE',
                victim_fon: '',
                victim_email: '',
                description: '',

                owner_street: '',
                owner_zipcode: '',
                owner_city: '',
                owner_additional: '',
                owner_countrycode: 'DE',
                owner_name: '',
                owner_email: '',
                owner_fon: '',
            },
            showDirectDamagereportToPartnerModal: false,

            filename_modal_show: false,
            // filename_modal_form: true,
            filename_modal_item: null,
            filename_modal_item_name: '',

            files: [],
            valid: false,
            message_modal_show: false,
            del_modal_show: false,
            message_modal_item: {},
            rules: {
                required: v => !!v || 'Pflichtfeld - Bitte ausfüllen',
                min: v => { 
                    if(v){ 
                        if(v.length < 6){ 
                            return 'Geben Sie mindestens 6 Zeichen ein'; 
                        }else{ 
                            return true;
                        }
                    }else{
                        return true;
                    }
                },
                email: v => {
                    if(v){
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(v) || 'Bitte eine gültige E-Mail-Adresse eingeben'
                    }
                    return true;
                },
                maxdate: v => {
                    return this.$moment(v).isSameOrBefore() || 'Nur die Eingabe eines vergangenen Datums möglich';
                }
            }
        }
    },

    computed: {
        contract(){
            let c = this.$store.getters['contracts/getContractById'](this.$route.params.contract_id);
            if(c){
                if(!c.person_type){
                    c.person_type = c.type;
                }
                if(!c.productpartner){
                    c.productpartner = {};
                }else{
                    if(c.productpartner.damage_url){
                        this.showDirectDamagereportToPartnerModal = true;
                    }
                }
                return c;
            }else{
                return {};
            }
        },
        has_haftpflicht(){
            if(this.contract.kind){
                return this.contract.kind.search(/haftpflicht/i) >= 0
            }
            return false;
        },
        countryoptions(){
            return COUNTRY_OPTIONS;
        }
    },

    created(){
        this.getAddress();
    },

    methods: {
        getInfoModal(message){
            this.message_modal_item = message;
            this.message_modal_show = true;
        },

        getAddress(){
            let user_data = this.$store.state.user.data;
            let address = {};
            if(!this.contract.type || this.contract.type==''){
                address = this.$store.getters['addresses/getAddressesByType']('post')[0];
            }else{
                address = this.$store.getters['addresses/getAddressesByType'](this.contract.type)[0];
            }
            if(address){
                this.damagereport.owner_street = address.street;
                this.damagereport.owner_additional = address.additional;
                this.damagereport.owner_zipcode = address.zipcode;
                this.damagereport.owner_city = address.city;
                this.damagereport.owner_country = address.country;
            }
            if(_.isEmpty(this.damagereport.owner_name)){
                this.damagereport.owner_name = this.contract.person_type=='dritte' ? this.contract.person_name : this.$store.getters['user/getDisplayName'](false, this.contract.person_type);
            }
            this.damagereport.owner_email = user_data.email;
            this.damagereport.owner_fon = user_data.fon ? user_data.fon : this.$store.state.auth.fb.phoneNumber;
        },

        getFilenameRewriteModal(message){
            this.filename_modal_item = message;
            this.filename_modal_item_name = message.file_name;
            this.filename_modal_show = true;
        },

        setFilename(){
            this.filename_modal_item.file_name = this.filename_modal_item_name;
            this.filename_modal_show = false;
        },

        onFileChanged (event) {
            Array.from(event.target.files).forEach(file => {
                let file_type = (file.type.search("image")<0) ? 'pdf' : 'image';
                file.file_name = file.name;
                file.file_type = file_type;
                if(file.type.search("image")<0){
                    if(file.type != "application/pdf"){
                        this.$snotify.warning('Der Dateityp wird zZt. nicht unterstützt!', 'Warning');
                        return false;
                    }else{
                        this.files.push(file);
                    }
                }else{
                    const fileReader = new FileReader();
                    fileReader.readAsDataURL(file);
                    fileReader.addEventListener('load', () => {
                        file.file_url = fileReader.result;
                        this.files.push(file);
                    });
                }
                //console.log(file);
                return true
            });
        },

        adddamagereport () {
            if(this.$refs.form.validate()){
                this.loading = true;
                this.damagereport.owner_street = this.damagereport.owner_street ? this.damagereport.owner_street : '';
                this.damagereport.owner_additional = this.damagereport.owner_additional ? this.damagereport.owner_additional : '';
                this.damagereport.owner_zipcode = this.damagereport.owner_zipcode ? this.damagereport.owner_zipcode : '';
                this.damagereport.owner_city = this.damagereport.owner_city ? this.damagereport.owner_city : '';
                this.damagereport.owner_countrycode = this.damagereport.owner_countrycode ? this.damagereport.owner_countrycode : '';
                this.damagereport.owner_email = this.damagereport.owner_email ? this.damagereport.owner_email : '';
                this.damagereport.owner_fon = this.damagereport.owner_fon ? this.damagereport.owner_fon : '';
                this.damagereport.contract_id = this.contract.id;
                //console.log(this.damagereport, this.files);
                this.$store.dispatch('contracts/addDamageReport', {damagereport: this.damagereport, files: this.files}).then(newDamagereport => {
                    this.$store.dispatch('contracts/sendDamageReport2Support', {damagereport: newDamagereport, contract: this.contract}).then(result => {
                        this.$store.dispatch('chat/addUserChatMessage', {
                            title:'Schadenmeldung erstellt', 
                            content:'Sie haben eine Schadenmeldung neu hinzugefügt.', 
                            contract_id: newDamagereport.contract_id
                        });
                        this.$store.dispatch('chat/addUserChatMessage', {
                            title: 'Schadenmeldung versendet', 
                            content: `Wir haben Ihre Schadensmeldung an den Versicherer weitergeleitet. <br/>Wichtig! Bitte beauftragen Sie selbst keine Firma ohne eine vorherige Zusage vom Versicherer. Mit Ausnahme, um größeren bzw. weiteren Schaden zu vermeiden. Rufen Sie in Notfällen bitte direkt den Versicherer an. <br/>Sollten Sie noch Fragen haben, können Sie sich jederzeit an uns wenden.`, 
                            contract_id: newDamagereport.contract_id,
                            sender: 'support',
                            type: 'message'
                        });
                        this.$router.push({ path: `/contract/${newDamagereport.contract_id}?damagereport=1` });
                    }).catch(error => {
                        console.log(error);
                        this.$router.push({ path: `/contract/${newDamagereport.contract_id}?damagereport=0` });
                    });
                }).catch(error => {
                    console.log(error);
                    this.$snotify.error('Schadenmeldung konnte nicht versendet werden - bitte später versuchen.');
                }).finally(() => {
                    this.loading = false;
                });
            }
        }

    }
}
</script>

<style scoped>
    .v-btn--floating .v-icon{
        width:auto;
    }
</style>
